import { Component } from '@angular/core';
import { Http } from '@angular/http';
import { AlertController, LoadingController, MenuController, NavController, NavParams, Platform, ToastController } from 'ionic-angular';
import { Account } from '../../model/account';
import { ConfigService } from '../../providers/config';
import { UserService } from '../../providers/user';
import { ErrorHandling } from '../../shared/error.handling';
import { SearchPage } from '../search/search';
import { AppConfig } from "../../shared/app.config";

@Component({
    selector: 'page-login',
    templateUrl: 'login.html'
})
export class LoginPage {

    kennung: string = localStorage.getItem('kennung');
    account: Account = {
        username: this.kennung || '',
        password: '',
        endpoint: ''
    };
    error: boolean = false;
    errorMessage: string = '';
    logoutStatus: boolean = false;
    config: any = {};

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public menuCtrl: MenuController,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public toastCtrl: ToastController,
                public userService: UserService,
                public http: Http,
                public platform: Platform,
                public errorHandling: ErrorHandling,
                public configService: ConfigService,
                public categories: AppConfig) {

        this.logoutStatus = this.navParams.get('logoutStatus');
    }

    /**
     * Disables and hides side menu on login page
     */
    ionViewDidEnter() {
        this.config = this.configService.getConfig();
        if (!this.logoutStatus) {
            this.checkToken();
        }
        this.menuCtrl.swipeEnable(false, 'sideMenu');
        this.menuCtrl.enable(false, 'sideMenu');
    }

    /**
     * Checks if token is still valid
     */
    checkToken() {
        this.userService.checkValidToken().subscribe(
            (response) => {
                if (response) {
                    this.loadCategoriesAoT();
                } else {
                    this.navCtrl.setRoot(LoginPage);
                }
            },
            (error) => {
                console.error('login.ts - Error in checkToken(): ', error);
            });
    }

    /**
     * Loads categories once, so it is cached in service
     */
    loadCategoriesAoT() {
        this.categories.getCategories().subscribe(() => {
            this.navCtrl.setRoot(SearchPage);
        });
    }

    /**
     * Logs the user in
     * @param {Account} access
     */
    doLogin(access: Account) {
        let lastUsername = localStorage.getItem('kennung');
        if (lastUsername !== access.username) {
            localStorage.removeItem('kennung');
        }
        let loader = this.loadingCtrl.create({});
        loader.present();
        this.userService.doLogin(access)
            .subscribe(
                (response) => {
                    localStorage.setItem('nodetoken', response._body);
                    localStorage.setItem('kennung', access.username);
                    this.loadCategoriesAoT();
                    loader.dismiss();
                },
                (error) => {
                    this.errorHandling.handle(error, 'Login - doLogin');
                    loader.dismiss();
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts